import Vue from 'vue';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { faChevronUp, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronUp);
library.add(faExternalLinkAlt);
config.autoAddCss = false;

export default () => {
  Vue.component('font-awesome-icon', FontAwesomeIcon);
};
